import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=30ad777a&scoped=true&"
import script from "./SaveButton.vue?vue&type=script&lang=ts&"
export * from "./SaveButton.vue?vue&type=script&lang=ts&"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=30ad777a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad777a",
  null
  
)

export default component.exports